import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import SvgCheckmark from '../icons/SvgCheckmark';
const DropdownArrow = ({ expanded, onClick }) => {
    let arrowStyles = {
        height: "0.75em",
        width: "0.75em",
    };
    let degrees = expanded ? "0" : "270";
    return (_jsx("div", { className: "inline-block mr-4", onClick: onClick, children: _jsx("svg", { className: "text-gray-600", style: arrowStyles, viewBox: "0 0 255 255", children: _jsx("g", { id: "arrow-drop-down", transform: `rotate(${degrees}, 128, 128)`, children: _jsx("polygon", { points: "0,63.75 127.5,191.25 255,63.75 \t\t" }) }) }) }));
};
const ExpandableArea = ({ title, done, children, expandedStart = false, highlight = false, style = null }) => {
    let [expanded, setExpanded] = useState(expandedStart);
    const border = highlight ? "border-salmon-200" : "border-wfGray-300";
    return (_jsxs("div", { className: `p-4 border ${border} my-2`, style: style, children: [_jsxs("h4", { onClick: () => setExpanded(!expanded), className: "cursor-pointer", children: [_jsx(DropdownArrow, { expanded: expanded }), title, done && (_jsx("div", { className: "inline-block relative top-2 left-05 rounded-full px-4", children: _jsx(SvgCheckmark, { className: "text-black h-4 w-4 fill-current" }) }))] }), expanded && children] }));
};
export default ExpandableArea;
